module.exports = __webpack_public_path__ + "img/CRT_Weapon-Fan-02.4abef755.png";